"use client"

export type CacheStatus = "idle" | "loading" | "ready" | "error"

export interface CacheFetchOptions {
  force?: boolean
  background?: boolean
}

export function isStale(lastFetchedAt: number | null, maxAgeMs: number): boolean {
  if (!lastFetchedAt) {
    return true
  }

  return Date.now() - lastFetchedAt > maxAgeMs
}

export function cacheDebugLog(scope: string, event: string, details?: Record<string, unknown>) {
  if (process.env.NODE_ENV !== "development") {
    return
  }

  if (details) {
    console.log(`[cache:${scope}] ${event}`, details)
    return
  }

  console.log(`[cache:${scope}] ${event}`)
}
